import { ScheduleType } from "@/api/schedule/models";
import { PHOTO_RENEWAL_ALLOWED_NAVIGATION_PATHS, SCHEDULE_DETAIL_NAVIGATION_ITEMS } from "@/constants/schedule";

/**
 * Obtém os itens de navegação permitidos para o tipo de agendamento.
 *
 * Agendamentos de renovação de fotos exibem somente as etapas aplicáveis;
 * os demais tipos preservam todos os itens de navegação disponíveis.
 *
 * @param scheduleType - Tipo do agendamento, quando já carregado
 * @returns Itens de navegação permitidos para o agendamento
 */
export function getAllowedNavigationItems(scheduleType?: ScheduleType) {
  // TODO: Expandir a política quando novas regras de navegação forem aprovadas.
  if (scheduleType !== ScheduleType.PHOTO_RENEWAL) {
    return SCHEDULE_DETAIL_NAVIGATION_ITEMS;
  }

  return SCHEDULE_DETAIL_NAVIGATION_ITEMS.filter(({ path }) => PHOTO_RENEWAL_ALLOWED_NAVIGATION_PATHS.includes(path));
}
